import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { DecimalPipe } from '@angular/common';

import { BehaviorSubject, Observable } from "rxjs";
import { ModalDirective } from 'ngx-bootstrap/modal';

import { UserTableService } from 'src/service/user.service';

import { CustomerService, GeoAssetService } from 'src/api/services';
import { User,Customer, CustomerSummary, MapLayerItem, GeoAssetTypeDTO, GeoAssetDetailDTO, CreateGeoAssetRequest, UpdateGeoAssetRequest, CreateGeoAssetTypeRequest, UpdateGeoAssetTypeRequest } from 'src/api/models';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { MapLayerTableService } from 'src/service/map-layer.service';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { KeyValueConfig } from 'src/app/components/key-value-editor.ts/key-value-editor.component';
import { GeoAssetEditorComponent } from './editor/geo-asset-editor.component';


// todo: fix styles
// todo: install license

@Component({
  selector: 'app-geo-assets',
  templateUrl: './geo-assets.component.html',
  styleUrls: ['./geo-assets.component.css']
})
export class GeoAssetsComponent implements OnInit {

  @ViewChild('updateItemModal', { static: false }) updateItemModal: ModalDirective;
  @ViewChild('typesModal', { static: false }) typesModal: ModalDirective;
  @ViewChild('geoEditor', { static: false }) geoEditor: GeoAssetEditorComponent;

  public customers : CustomerSummary[];

  public currentAsset: GeoAssetDetailDTO | undefined = undefined;
  public currentType: GeoAssetTypeDTO | undefined = undefined;
  public editingTypeId: number | null = null;

  public geoAssetTypes: GeoAssetTypeDTO[] = [];
  public geoAssets: GeoAssetDetailDTO[] = [];
  
  // Pagination and Search
  public loading: boolean = false;
  public searchFilter: string = '';
  public pageSize: number = 100;
  public pageIndex: number = 1;
  public totalItems: number = 100;
  public maxPages: number = 4;
  public selectedColumn: string = 'name';
  public sortOrder: string = 'ascending';
  public selectedTypeFilter: number | null = null;
  private lastSearchText: string = '';
  private searchTimeout: any;

  constructor(
    public service: GeoAssetService,
    public azureAuthService: AzureAuthService,
    private customerService: CustomerService,
    public app: ApplicationConfigService,
    private cdr: ChangeDetectorRef,
    private decimalPipe: DecimalPipe
    ) { 
    //this.remoteData = this.service.remoteData;
    this.customerService.CustomerGetAllCustomers().subscribe(c => this.customers = c);
    app.customerChanged$.subscribe(cid => {
      this.ngOnInit();
    });

  }

  ngOnInit(): void {    
    if (this.azureAuthService.isGlobalViewer()){
      if (this.app.customers == null){
        this.customerService.CustomerGetAllCustomers().subscribe(c => {           
          this.app.customers = c;//.filter(c=>c.active);          
        });
      }
    } 
    if (this.app.customerId == null) {
      this.app.customerId = this.azureAuthService.userProfile.customerId;
    }
    
    // Initialize currentType to prevent undefined errors
    this.currentType = {} as GeoAssetTypeDTO;
    
    // Load types first, then search
    this.service.GeoAssetGetAllGeoAssetTypes(this.app.customerId).subscribe(types => {
      this.geoAssetTypes = types;
      this.doSearch();
    });
  }

  public getCustomerName(customerId: number) {
    for (var c of this.customers){
      if (c.customerId == customerId){
        return c.customerName;
      }
    }
    return customerId;
  }

  public getTypeName(typeId: number): string {
    const type = this.geoAssetTypes.find(t => t.id === typeId);
    return type ? type.name : typeId?.toString() || '';
  }
  public clearAsset() {
    this.currentAsset = {} as GeoAssetDetailDTO;
  }

  public editAsset(asset: GeoAssetDetailDTO) {
    // Fetch the geometry from the server before showing modal
    if (asset.id) {
      this.service.GeoAssetGetGeoAssetGeometry({ id: asset.id, customerId: this.app.customerId }).subscribe(geometry => {
        // Handle both string response and object response
        let wktString: string;
        if (typeof geometry === 'string') {
          // Try to parse as JSON first
          try {
            const parsed = JSON.parse(geometry);
            wktString = parsed.geometryWKT || geometry;
          } catch {
            // Not JSON, use as-is
            wktString = geometry;
          }
        } else if (geometry && (geometry as any).geometryWKT) {
          wktString = (geometry as any).geometryWKT;
        }
        
        // Create a new object with the geometry
        this.currentAsset = { 
          ...asset,
          geometryWKT: wktString
        };
        
        console.log('Opening modal with geometry:', wktString);
        this.updateItemModal.show();
      }, error => {
        console.error('Error fetching geometry:', error);
        // Show modal anyway even if geometry fetch fails
        this.currentAsset = { ...asset };
        this.updateItemModal.show();
      });
    } else {
      this.currentAsset = { ...asset };
      this.updateItemModal.show();
    }
  }

  public removeAsset(asset: GeoAssetDetailDTO) {
    // TODO: Implement delete when API is ready
    // if (confirm(`Are you sure you want to delete "${asset.name}"?`)) {
    //   this.service.GeoAssetDeleteGeoAsset({ id: asset.id }).subscribe(() => {
    //     this.ngOnInit();
    //   });
    // }
    alert('Delete functionality not yet available in API');
  }

  public updateAsset() {
    if (!this.currentAsset.id) {
      console.error('Cannot update: asset has no ID');
      return;
    }

    // Get the geometry from the editor
    const geometryWKT = this.geoEditor?.getGeometryWKT();

    const request: UpdateGeoAssetRequest = {
      identifier: this.currentAsset.identifier,
      name: this.currentAsset.name,
      description: this.currentAsset.description,
      geoAssetTypeId: this.currentAsset.geoAssetTypeId,
      geometryWKT: geometryWKT,
      metaData: this.currentAsset.metaData,
      styling: this.currentAsset.styling
    };

    this.service.GeoAssetUpdateGeoAsset({ 
      id: this.currentAsset.id,
      customerId: this.app.customerId,
      request: request 
    }).subscribe({
      next: (result) => {
        console.log('Asset updated successfully:', result);
        this.doSearch(); // Refresh the list
      },
      error: (error) => {
        console.error('Error updating asset:', error);
        alert('Error updating asset: ' + (error.error?.message || error.message));
      }
    });
  }

  public addAsset() {
    // Get the geometry from the editor
    const geometryWKT = this.geoEditor?.getGeometryWKT();

    const request: CreateGeoAssetRequest = {
      customerId: this.app.customerId,
      identifier: this.currentAsset.identifier,
      name: this.currentAsset.name,
      description: this.currentAsset.description,
      geoAssetTypeId: this.currentAsset.geoAssetTypeId,
      geometryWKT: geometryWKT,
      metaData: this.currentAsset.metaData,
      styling: this.currentAsset.styling
    };

    this.service.GeoAssetCreateGeoAsset(request).subscribe({
      next: (result) => {
        console.log('Asset created successfully:', result);
        this.doSearch(); // Refresh the list
      },
      error: (error) => {
        console.error('Error creating asset:', error);
        alert('Error creating asset: ' + (error.error?.message || error.message));
      }
    });
  }

  public onModalShown() {
    // Refresh the map when modal is fully shown
    if (this.geoEditor) {
      setTimeout(() => {
        this.geoEditor.refreshMap();
      }, 100);
    }
  }

  // Search and Pagination Methods
  public onInput(event: Event): void {
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      this.doSearch();
    }, 250); // 250ms debounce time
  }

  public doSearch() {
    if (this.searchFilter == null) {
      this.searchFilter = '';
    }

    if (this.loading) {
      return; // Don't search if already loading
    }

    // Reset to page 1 if search text changed
    if (this.lastSearchText !== this.searchFilter) {
      this.pageIndex = 1;
      this.cdr.detectChanges();
    }
    this.lastSearchText = this.searchFilter;

    this.loading = true;

    // Use selectedTypeFilter if set, otherwise use 0 (all types)
    const typeFilter = this.selectedTypeFilter || 0;

    this.service.GeoAssetSearch({
      customerId: this.app.customerId,
      type: typeFilter,
      searchSize: this.pageSize,
      pageIndex: this.pageIndex,
      search: this.searchFilter,
      sortColumn: this.selectedColumn,
      sortOrder: this.sortOrder
    }).subscribe({
      next: (results) => {
        console.log('Search Results', results);
        this.loading = false;
        this.geoAssets = results;

        // Handle pagination - if we got a full page, there might be more
        if (results.length >= this.pageSize) {
          this.totalItems = Math.max(((this.pageIndex - 1) * this.pageSize) + this.pageSize + 1, 100);
          this.maxPages = 4;
        } else {
          this.totalItems = ((this.pageIndex - 1) * this.pageSize) + results.length;
          if (this.pageIndex < 4) {
            this.maxPages = this.pageIndex;
          }
        }
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.loading = false;
        console.error('Search error:', error);
        this.geoAssets = [];
        this.cdr.detectChanges();
      }
    });
  }

  public columnSort(column: string) {
    if (this.selectedColumn === column) {
      this.sortOrder = this.sortOrder === 'ascending' ? 'descending' : 'ascending';
    } else {
      this.sortOrder = 'ascending';
    }
    this.selectedColumn = column;
    this.pageIndex = 1; // Reset to first page when sorting changes
    console.log('Sort column:', this.selectedColumn, this.sortOrder);
    this.doSearch();
  }

  public columnSortStyle(column: string): string {
    if (column === this.selectedColumn && this.sortOrder === 'descending') {
      return 'fa fa-sort-desc';
    }
    if (column === this.selectedColumn && this.sortOrder === 'ascending') {
      return 'fa fa-sort-asc';
    }
    return 'fa fa-sort';
  }

  public setPageSize(size: number) {
    this.pageSize = size;
    this.pageIndex = 1; // Reset to first page
    this.doSearch();
  }

  public pageChange(event: any) {
    console.log('Page change event:', event);
    this.pageIndex = event.page;
    this.doSearch();
  }

  public filterByType(typeId: number | null) {
    this.selectedTypeFilter = typeId;
    this.pageIndex = 1; // Reset to first page
    this.doSearch();
  }

  // Geo Asset Type Management
  public addNewTypeRow() {
    // Add a new empty type to the array with a temporary negative ID
    const newType: GeoAssetTypeDTO = {
      id: -(Date.now()), // Temporary negative ID for new types
      name: '',
      description: '',
      customerId: this.app.customerId
    } as any;
    this.geoAssetTypes.unshift(newType);
    this.editingTypeId = newType.id;
  }

  public editType(type: GeoAssetTypeDTO) {
    this.editingTypeId = type.id;
  }

  public cancelEditType(type: GeoAssetTypeDTO) {
    // If it's a new type (negative ID), remove it from the array
    if (type.id < 0) {
      const index = this.geoAssetTypes.findIndex(t => t.id === type.id);
      if (index > -1) {
        this.geoAssetTypes.splice(index, 1);
      }
    }
    this.editingTypeId = null;
    this.loadTypes(); // Reload to reset any changes
  }

  public saveType(type: GeoAssetTypeDTO) {
    if (!type.name?.trim()) {
      alert('Type name is required');
      return;
    }

    if (type.id < 0) {
      // New type - create it
      const request: CreateGeoAssetTypeRequest = {
        name: type.name,
        description: type.description,
        customerId: this.app.customerId
      };

      this.service.GeoAssetCreateGeoAssetType({ request, customerId: this.app.customerId }).subscribe({
        next: (result) => {
          console.log('Type created successfully:', result);
          this.editingTypeId = null;
          this.loadTypes();
        },
        error: (error) => {
          console.error('Error creating type:', error);
          alert('Error creating type: ' + (error.error?.message || error.message));
        }
      });
    } else {
      // Existing type - update it
      const request: UpdateGeoAssetTypeRequest = {
        name: type.name,
        description: type.description
      };

      this.service.GeoAssetUpdateGeoAssetType({ id: type.id, customerId: this.app.customerId, request }).subscribe({
        next: (result) => {
          console.log('Type updated successfully:', result);
          this.editingTypeId = null;
          this.loadTypes();
        },
        error: (error) => {
          console.error('Error updating type:', error);
          alert('Error updating type: ' + (error.error?.message || error.message));
        }
      });
    }
  }

  private loadTypes() {
    this.service.GeoAssetGetAllGeoAssetTypes(this.app.customerId).subscribe(types => {
      this.geoAssetTypes = types;
      this.doSearch(); // Refresh the list after types are updated
    });
  }
}
